import { memo } from "react";
import "./style.css";

const AboutComponent = () => {
  return <>About Page</>;
};

export default memo(AboutComponent);
